import React from "react";
import View from "@mui/material/Box"; //rename for portability to React Native
import "./CompleteProfile.css";

import ProfileVTTQuestion from "components/ProfileInterview/ProfileVTTQuestion";
import { BackNextBtn } from "components/BackNextBtn/BackNextBtn";
import { CompleteProfileContainer } from "@components/CompleteProfileContainer/CompleteProfileContainer";

export const VTTQuestionComponent = ({
    state,
    handleEditProfile,
    pushCounter,
    skipButton,
    goBack,
    counter,
    length,
    filterFields,
    loading,
    updateFiltersFieldsAsync,
}) => {
    return (
        <>
            <CompleteProfileContainer rootContainerClass="question-dm-or-player">
                <View className="top-text"></View>
                <View className="question-container">
                    <ProfileVTTQuestion
                        state={state}
                        pushCounter={pushCounter}
                        handleEditProfile={handleEditProfile}
                        filterFields={filterFields}
                        updateFiltersFieldsAsync={updateFiltersFieldsAsync}
                        loading={loading}
                    />
                </View>
                <BackNextBtn goBack={goBack} counter={counter} length={length} nextBtn={skipButton} />
            </CompleteProfileContainer>
        </>
    );
};
